import React from 'react'
import { PHeading } from "@porsche-design-system/components-react";

function MissingPage() {
    return (
        <PHeading tag="h2" size="large" align="center" autoFocus={false} inert>Page Not Found</PHeading>
    )
}

export default MissingPage;